// extracted by mini-css-extract-plugin
module.exports = {"root":"NonDupPatients_root__3L11w"};